/**
 * CSV helpers for the CRM module.
 */

const BOM = String.fromCharCode(0xfeff)

// Cells beginning with these are treated as formulas by Excel / Sheets.
const FORMULA_START = /^[=+\-@\t\r]/

/**
 * Escape one cell: neutralise formulas (user text such as a contact name must never run as one),
 * then quote when it contains a comma, quote or line break.
 * @param {unknown} value
 * @returns {string}
 */
export const csvCell = value => {
    if (value === null || value === undefined) return ''
    let text = Array.isArray(value) ? value.join('; ') : String(value)
    if (FORMULA_START.test(text)) text = `'${text}`
    return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
}

/**
 * @template T
 * @param {T[]} rows
 * @param {{ header: string, value: (row: T) => unknown }[]} columns
 * @returns {string} CSV text with CRLF line endings
 */
export const toCsv = (rows, columns) => {
    const lines = [columns.map(c => csvCell(c.header)).join(',')]
    rows.forEach(row => lines.push(columns.map(c => csvCell(c.value(row))).join(',')))
    return lines.join('\r\n')
}

/**
 * Trigger a browser download of text content.
 * @param {string} filename
 * @param {string} text
 * @param {string} [mime]
 * @param {boolean} [bom] prefix a UTF-8 byte order mark (default true)
 */
export const downloadText = (filename, text, mime = 'text/csv;charset=utf-8', bom = true) => {
    // BOM so Excel reads UTF-8 names correctly (not wanted for .ics).
    const blob = new Blob([`${bom ? BOM : ''}${text}`], { type: mime })
    const url = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = filename
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
    URL.revokeObjectURL(url)
}
